import request from '../request';

export function getTokenByUniqueId(uniqueId) {
  return request({
    method: 'post',
    url: '/api-internet-user/open/study/room/device/auth',
    data: {
      deviceSn: uniqueId,
    },
  });
}

export function checkToken() {
  return request({
    method: 'post',
    url: '/api-internet-user/mp/ai/user/auth',
    data: {},
  });
}
// 记录日志 /api-internet-user/mp/ai/user/event/log
export function logApi(data) {
  return request({
    method: 'post',
    url: '/api-internet-user/mp/ai/user/event/log',
    data,
  });
}

export function getAppList() {
  return request({
    method: 'get',
    url: '/api-internet-user/mp/study/room/app/list',
  });
}
